import { gql } from "@apollo/client";

export const GET_STATEMENTS = gql`
  query getStatements($first: Int, $after: String, $accountId: String) {
    getStatements(first: $first, after: $after, accountId: $accountId) {
      edges {
        cursor
        node {
          id
          accountId
          periodMonth
          periodStart
          periodEnd
          statementDate
          startingBalance {
            amount
            currency
          }
          endingBalance {
            amount
            currency
          }
          statementBalance {
            amount
            currency
          }
          statementUrl
          account {
            id
            name
            last4
            accountType
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
